import { IFormTypesGroupCategoryService } from "../../service/formconfiguration/FormTypesGroupCategoryService";

export default class GetFormTypesGroupsInteractor {
  private formTypesGroupCategoryService: IFormTypesGroupCategoryService;

  constructor(formTypesGroupCategoryService) {
    this.formTypesGroupCategoryService = formTypesGroupCategoryService;
  }

  async execute(formTypesGroupCategoryCode: string) {
    return this.formTypesGroupCategoryService.getFormTypesGroups(
      formTypesGroupCategoryCode
    );
  }
}
